import styled from "styled-components";

import "../../../GlobalStyles/Font.css";

export const HeaderContainer = styled.div`
  max-width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 16px 0px;

  @media (min-width: 428px) {
    width: 396px;
    padding: 20px 0px;
    margin-left: auto;
    margin-right: auto;
  }

  @media (min-width: 744px) {
    width: 712px;
    padding: 20px 0px 0px;
    margin-left: auto;
    margin-right: auto;
  }

  @media (min-width: 1024px) {
    width: 976px;
    padding: 20px 0px 0px;
    margin-left: auto;
    margin-right: auto;
  }

  @media (min-width: 1440px) {
    width: 1392px;
    padding: 30px 0px 0px;
    margin-left: auto;
    margin-right: auto;
  }
`;

export const Logo = styled.h1`
  font-size: 20px;
  font-family: "Exo2 Medium";
  line-height: 1.2;
  color: #000;

  @media (min-width: 428px) {
    font-size: 24px;
    line-height: 1.2;
  }

  @media (min-width: 1024px) {
    font-size: 32px;
    line-height: 1.18;
  }

  @media (min-width: 1440px) {
    font-size: 36px;
    line-height: 1.19;
  }
`;

export const LogoColor = styled.span`
  color: #1ac63f;
`;

export const ButtonsContainer = styled.div`
  max-width: 100%;
  display: flex;
  gap: 10px;
  position: relative;

  @media (min-width: 428px) {
    gap: 20px;
  }
`;

// button Sign Up

export const ButtonSignUp = styled.button`
  color: #1ac63f;
  font-size: 20px;
  font-family: "Exo2 Medium";
  line-height: 24px;
  cursor: pointer;
  transition: 350ms cubic-bezier(0.61, 0, 0.51, 1);

  &:hover:after {
    content: "";
    width: 100%;
    border: 3px solid #1ac63f;
    transition: position 650ms 350ms cubic-bezier(0.61, 0, 0.51, 1);
    border-radius: 5px;
    position: absolute;
    left: 0px;
    top: 30px;
  }

  @media (min-width: 428px) {
    font-size: 24px;
    line-height: 1.2;

    &:hover:after {
      content: "";
      border-radius: 5px;
      position: absolute;
      left: 0px;
      top: 35px;
    }
  }

  @media (min-width: 1024px) {
    font-size: 32px;
    line-height: 1.18;

    &:hover:after {
      content: "";
      border-radius: 5px;
      position: absolute;
      left: 0px;
      top: 45px;
    }
  }

  @media (min-width: 1440px) {
    font-size: 36px;
    line-height: 1.19;

    &:hover:after {
      content: "";
      border-radius: 5px;
      position: absolute;
      left: 0px;
      top: 50px;
    }
  }
`;

export const ButtonSignIn = styled.button`
  font-size: 20px;
  font-family: "Exo2 Medium";
  line-height: 24px;
  cursor: pointer;
  color: #000;

  &:hover:after {
    content: "";
    width: 100%;
    border: 3px solid #000;
    border-radius: 5px;
    position: absolute;
    left: 0;
    right: 0;
    top: 30px;
  }

  @media (min-width: 428px) {
    font-size: 24px;
    line-height: 1.2;

    &:hover:after {
      content: "";
      border-radius: 5px;
      position: absolute;
      top: 35px;
    }
  }

  @media (min-width: 1024px) {
    font-size: 32px;
    line-height: 1.18;

    &:hover:after {
      content: "";
      border-radius: 5px;
      position: absolute;
      top: 45px;
    }
  }

  @media (min-width: 1440px) {
    font-size: 36px;
    line-height: 1.19;

    &:hover:after {
      content: "";
      border-radius: 5px;
      position: absolute;
      top: 50px;
    }
  }
`;
